module.exports = __webpack_public_path__ + "assets/img/url-qrcode-placeholder.12913742.svg";